/**
 * Catálogo de campos del Data Explorer (FIELD_DATA_BY_ID, etc.).
 *
 * Singleton cacheado en memoria. El catálogo es global por agencia y casi nunca cambia
 * en la vida de la sesión, así que la primera carga sirve a todos los consumidores
 * (Explorer, Portal Reportes, etc.).
 *
 * El endpoint es el mismo que usa `DataExplorerPage.componentDidMount` —
 * mantenemos ese contrato como fuente de verdad única.
 */
import { APIClient } from './APIClient';
import { API_URL } from '../settings/local_settings';

let cache = null;
let inflight = null;

export function loadFieldsCatalog() {
    if (cache) return Promise.resolve(cache);
    if (inflight) return inflight;
    inflight = new APIClient(API_URL + 'node-to-gsheet/sync-configuration/form-data')
        .call('GET')
        .then((data) => {
            cache = (data && data.fields_data) || null;
            inflight = null;
            return cache;
        })
        .catch(() => {
            inflight = null;
            return null;
        });
    return inflight;
}

export function clearFieldsCatalogCache() {
    cache = null;
    inflight = null;
}
